// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fVj61","colBig":"styles_colBig__1sbhv","colSmall":"styles_colSmall__luidr"};